(function () {
const $8d4fc47ac963f0d5$var$replaceUrlPlaceholders = (url)=>url.replace("%url%", encodeURIComponent(`${window.location.protocol}://${window.location.host}${window.location.pathname}`)).replace("%title%", encodeURIComponent(document.title));
class $8d4fc47ac963f0d5$var$ShareButtons {
    constructor(el){
        el.querySelectorAll(".share-buttons__button").forEach((button)=>button.href = $8d4fc47ac963f0d5$var$replaceUrlPlaceholders(button.dataset.shareUrl));
    }
}
document.querySelectorAll(".wp-block-occasions-share-buttons").forEach((el)=>new $8d4fc47ac963f0d5$var$ShareButtons(el));

})();
//# sourceMappingURL=share-buttons-script.js.map
